var React = require('react');

function QuestionMarkIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_113","data-name":"Ellipse 113","cx":"25","cy":"25","r":"25","fill":"none","key":0}),React.createElement("text",{"id":"_","data-name":"?","transform":"translate(15.5 38)","fill":"#27788c","fontSize":"35","fontFamily":"sans-serif","key":1},React.createElement("tspan",{"x":"0","y":"0"},"?"))]);
}

QuestionMarkIcon.defaultProps = {"id":"ICON_-_Question_Mark","data-name":"ICON - Question Mark","width":"50","height":"50","viewBox":"0 0 50 50"};

module.exports = QuestionMarkIcon;

QuestionMarkIcon.default = QuestionMarkIcon;
